import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';

export type SseTopic = 'jobs' | 'vms' | 'states' | 'forms' | 'inbound';

export interface SseEvent<T = unknown> {
  topic: SseTopic;
  type: string;
  data: T;
  ts: string;
}

export function useSse(topics: SseTopic[], onEvent: (e: SseEvent) => void, enabled = true) {
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    if (!enabled) return;
    const token = useAuthStore.getState().token;
    if (!token) return;

    const url = `/v1/stream?topics=${encodeURIComponent(topics.join(','))}&token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);

    es.onmessage = (msg) => {
      try {
        const parsed = JSON.parse(msg.data) as SseEvent;
        handlerRef.current(parsed);
      } catch {
        // ignore malformed
      }
    };

    es.onerror = () => {
      es.close();
    };

    return () => {
      es.close();
    };
  }, [enabled, topics.join(',')]);
}
